import { createFileRoute, redirect } from '@tanstack/react-router'

import { AdminLoginForm } from '#components/features/auth/admin-login-form'
import { authQueryOptions } from '#hooks/use-auth'
import { useWaiterStore } from '#stores/use-waiter-store'

export const Route = createFileRoute('/login')({
  beforeLoad: async ({ context }) => {
    const authData = await context.queryClient.ensureQueryData(authQueryOptions)
    const waiterToken = localStorage.getItem('@usecomanda:waiter_token')

    if (authData.user) {
      throw redirect({ to: '/dashboard', replace: true })
    }

    if (waiterToken) {
      throw redirect({
        to:
          useWaiterStore.getState().waiter?.role === 'kitchen'
            ? '/cozinha'
            : '/mesas',
        replace: true,
      })
    }
  },
  head: () => ({
    meta: [
      { title: 'Entrar | UseComanda' },
      {
        name: 'description',
        content:
          'Acesse o Painel do Gestor. Gerencie seu restaurante, mesas, comandas e faturamento em tempo real.',
      },
      { property: 'og:title', content: 'Painel do Gestor | UseComanda' },
      {
        property: 'og:description',
        content: 'Faça login para gerenciar o seu negócio.',
      },
    ],
  }),
  component: LoginPage,
})

function LoginPage() {
  return (
    <div className="bg-background flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
      <div className="w-full max-w-sm">
        <AdminLoginForm />
      </div>
    </div>
  )
}
